export const PASSWORD_SETUP_CONTINUE_URL = 'https://portal.artgoldjewelry.com/login'

export function passwordEmailFailure(error) {
  if (error?.code === 'auth/too-many-requests') return 'Too many email requests. Wait a few minutes, then send the password email again.'
  if (error?.code === 'auth/network-request-failed') return 'The email request could not reach Firebase. Check the connection and try again.'
  return 'The password email could not be requested. The account is saved; use Send password email to retry.'
}

export async function invitePortalUser({ email, role }, { createUser, sendEmail }) {
  const response = await createUser({ email: String(email || '').trim(), role: role || undefined })
  const user = response?.user
  if (!user?.uid || !user?.email) throw new Error('The app could not confirm account creation. Refresh the user list before trying again.')
  const account = { uid: user.uid, email: user.email }
  if (response.roleAssigned === false) return { user: account, emailRequested: false,
    emailError: 'The account was created, but its role could not be assigned. Set the role in the user list, then send the password email.' }
  try {
    await sendEmail(account.email)
    return { user: account, emailRequested: true }
  } catch (error) {
    // A failed email must never trigger another account-creation attempt or
    // discard the created identity. Only a public retry message is returned.
    return { user: account, emailRequested: false, emailError: passwordEmailFailure(error) }
  }
}
